import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({row, settings, globalVariables}) => {
    if(row.error_id === MessageCodes.Internal.SRC00.error_id) {
        return  (
            <ResultText>
                {row.error_message}
            </ResultText>
        )
    }
    else if(row.error_id === MessageCodes.Internal.FW01.error_id) {
        return (
            <>
                <ResultText>
                    {/*There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or lower than {settings.thresholds.delta_ws_lt} at the following {row?.data?.length} cross sections.*/}
                    There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or negative at the following {row?.data?.length} cross sections.
                    <EmptyLine />
                </ResultText>
                <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section || '{cross_section}'} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.femafw_prof_delta_ws || '{femafw_prof_delta_ws}'}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.FW01IB.error_id) {
        return (
            <>
                <ResultText>
                    {/*There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or lower than {settings.thresholds.delta_ws_lt} at the following {row?.data?.length} internal cross sections.*/}
                    There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or negative at the following {row?.data?.length} internal bridge cross sections.
                    <EmptyLine />
                </ResultText>
                <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section || '{cross_section}'} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.femafw_prof_delta_ws || '{femafw_prof_delta_ws}'}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </>
        )
    }
}